export interface RipButtonProps {
  onClick?: () => void;
  /** What the pill reads: "RIP 2 PACKS", "RIP FOR $25", or the reason the
   *  pack can't be bought ("Sold out"). */
  label: string;
  /** Screen-reader label; the visible one is terse. */
  ariaLabel?: string;
  /** card — 52 tall in the desktop price card; dock — 46 on the phone. */
  variant?: 'card' | 'dock';
  disabled?: boolean;
}

/**
 * The green RIP pill of the glass storefront (repackz-handoff §7.3
 * `greenFill`): the operator's button colour with a white inner glow and a
 * hairline rim. Locked, it turns to plain glass with muted text.
 */
export function RipButton({ onClick, label, ariaLabel, variant = 'card', disabled = false }: RipButtonProps) {
  const size =
    variant === 'card'
      ? 'h-[52px] text-[18px] tracking-[-0.3px]'
      : 'h-[46px] min-w-0 flex-1 text-[15px] tracking-[-0.3px]';
  const surface = disabled
    ? '[background:var(--glass-locked-fill)] [color:var(--glass-locked-text)]'
    : '[background:var(--co-RipButton-discFill,var(--ui-button))] [color:var(--co-RipButton-discText,var(--ui-button-text))] ' +
      '[box-shadow:var(--glass-rip-glow)] [text-shadow:0_0_5px_rgba(255,255,255,0.35)]';

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      data-co-component="RipButton"
      aria-label={ariaLabel ?? label}
      className={
        `${size} ${surface} flex w-full cursor-pointer items-center justify-center rounded-full ` +
        'border-[0.5px] border-solid [border-color:var(--glass-rip-rim)] px-4 ' +
        'font-extrabold uppercase leading-4 whitespace-nowrap ' +
        'transition-[filter,transform] active:scale-[0.99] hover:brightness-105 ' +
        'disabled:cursor-not-allowed disabled:active:scale-100 disabled:hover:brightness-100'
      }
    >
      {label}
    </button>
  );
}
